// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorMessage_container__EX8Fr","message":"ErrorMessage_message__r_5Uq"};